<!-- eslint-disable vue/no-mutating-props -->
<template>
    <ion-header>
        <ion-toolbar mode="md">
            <ion-buttons slot="start"> </ion-buttons>
            <ion-title style="font-family: 'San Francisco', sans-serif; font-weight: 700; text-align: center"
                >Warning - Rules</ion-title
            >
        </ion-toolbar>
    </ion-header>
    <ion-content class="ion-no-padding" style="--background: rgb(239, 246, 255)">
        <ion-card>
            <ion-card-content>
                <p>The reservation violates some rules:</p>
                <br />
                <div v-for="item in errors" :key="item.name">
                    <p>
                        <b>{{ item.name }}</b>
                    </p>
                    <ul>
                        <li v-for="error in item.errors" :key="error.id">
                            {{ error }}
                        </li>
                    </ul>
                </div>
                <br />
                <p>Please press "Proceed Anyway" if this is correct.</p>
            </ion-card-content>
        </ion-card>

        <ion-grid class="ldx-bottom-fixed">
            <ion-row>
                <ion-col>
                    <ion-button
                        style="
                            width: -webkit-fill-available;
                            --border-radius: 10px;
                            --border-width: 2px;
                            --border-style: solid;
                        "
                        color="danger"
                        @click="cancel()"
                        >Cancel</ion-button
                    >
                </ion-col>
                <ion-col>
                    <ion-button
                        style="
                            width: -webkit-fill-available;
                            --border-radius: 10px;
                            --border-width: 2px;
                            --border-style: solid;
                        "
                        color="primary"
                        size="medium"
                        @click="confirm()"
                        >Proceed Anyway</ion-button
                    >
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-content>
</template>

<script lang="ts">
    import { modalController } from '@ionic/vue';
    import { arrowBackOutline } from 'ionicons/icons';
    import { defineComponent } from 'vue';

    export default defineComponent({
        components: {},
        props: ['errors'],
        setup() {
            const cancel = () => {
                return modalController.dismiss(false);
            };

            const confirm = () => {
                return modalController.dismiss(true);
            };

            return {
                arrowBackOutline,
                cancel,
                confirm,
            };
        },
    });
</script>

<style scoped></style>
